export function shellPieceIndex(name){const match=/^shell_(\d+)(?:_|$)/.exec(name);return match?Number(match[1]):-1;}
import {CRACK_PROFILES} from './crack-profiles.js';
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const DRAIN=2.5,RECOIL=.22,POP_LIFE=1.2;
// A held press loads the wax shell with stress. At full stress it snaps in one
// burst: the crack front runs outward from the finger across a cluster of
// pieces, the shell recoils, and the weakened shell loads faster next time.
export class CrackleShell {
  constructor(centers,damage=[],profile=CRACK_PROFILES.wax){
    this.profile=profile;this.centers=centers;this.ages=new Float64Array(centers.length).fill(-1);
    for(const i of damage)if(Number.isInteger(i)&&i>=0&&i<centers.length)this.ages[i]=2;
    this.clock=0;this.charge=0;this.recoil=0;this.lockout=0;this.pending=[];this.animating=false;
  }
  get damage(){return Array.from(this.ages.keys()).filter(i=>this.ages[i]>=0);}
  isBroken(index){return this.ages[index]>=0;}
  snap(contact){
    const scheduled=new Set(this.pending.map(p=>p.i));
    const open=this.centers.map((p,i)=>({i,d:this.ages[i]>=0||scheduled.has(i)?Infinity:(p[0]-contact[0])**2+(p[1]-contact[1])**2+(p[2]-contact[2])**2})).filter(p=>Number.isFinite(p.d)).sort((a,b)=>a.d-b.d);
    if(!open.length)return;
    const fraction=1-open.length/this.centers.length;
    const [first,last]=this.profile.count,count=Math.round(first+(last-first)*fraction);
    // A nearly gone shell shatters completely rather than leaving a few stragglers.
    const chosen=open.length<=count+3?open:open.slice(0,count);
    const span=this.profile.span??.10;
    chosen.forEach((p,k)=>this.pending.push({i:p.i,at:this.clock+span*(chosen.length>1?k/(chosen.length-1):0)}));
    this.charge=0;this.recoil=1;this.lockout=RECOIL+span;
  }
  step(elapsed,contact){
    const dt=clamp(elapsed,0,1/30);this.clock+=dt;
    for(let i=0;i<this.ages.length;i++)if(this.ages[i]>=0&&this.ages[i]<POP_LIFE)this.ages[i]+=dt;
    this.recoil=Math.max(0,this.recoil-dt/RECOIL);this.lockout=Math.max(0,this.lockout-dt);
    const broken=[];
    if(contact){
      if(!this.lockout&&!this.pending.length){
        const open=this.ages.reduce((n,a)=>n+(a<0),0),fraction=1-open/this.centers.length;
        const [slow,fast]=this.profile.charge;
        this.charge=Math.min(1,this.charge+dt/(slow-(slow-fast)*fraction));
        if(this.charge>=1&&open)this.snap(contact);
      }
    }else this.charge=Math.max(0,this.charge-dt*DRAIN);
    // Fuses keep burning after release, so a started burst always finishes.
    this.pending=this.pending.filter(p=>{if(p.at>this.clock)return true;this.ages[p.i]=0;broken.push(p.i);return false;});
    this.animating=this.charge>0||this.recoil>0||this.pending.length>0||this.ages.some(a=>a>=0&&a<POP_LIFE);
    return broken;
  }
}
